import React from 'react';
import { Control, Controller } from 'react-hook-form';
import UnitAutocompleteSelectField, {
  UnitAutocompleteFieldProps,
} from 'src/components/UnitsAutocompleteField';
import type { VerifyPolicyInput } from '../../../../redux/reducer/v2/verifyPolicy';
import { OnFieldBlurType } from '../../types';

type Props = {
  control: Control<VerifyPolicyInput>;
  onFieldBlur: OnFieldBlurType;
  buildingId?: string;
} & Omit<UnitAutocompleteFieldProps, 'onChange'>;

function UnitAutocompleteField({
  control,
  onFieldBlur,
  buildingId,
  disabled,
  ...props
}: Props) {
  return (
    <Controller
      control={control}
      name="unit"
      rules={{
        required: false,
      }}
      render={({ field: { onChange, onBlur, value, name, ref } }) => {
        return (
          <UnitAutocompleteSelectField
            buildingId={buildingId}
            disabled={disabled}
            textFieldProps={{
              ref,
              label: 'Unit Number',
              onBlur: onFieldBlur(onBlur, name, value?.id),
              inputProps: {
                'data-testid': 'start-application-address-buildingunit',
                maxLength: 50,
              },
            }}
            onChange={onChange}
            name={name}
            value={value}
            {...props}
          />
        );
      }}
    />
  );
}

export default UnitAutocompleteField;
